// Unidad de medida de la producción, derivada del formato del SKU
// (propuesta 2026-10-alimentos-rionegro).
//
// Las líneas de proceso (SKUs a granel) cuentan kilogramos; todo lo demás
// sigue contando paquetes. No existe columna de unidad en `skus`: la regla es
// `skus.formato = 'GRANEL'` → kg. Ningún otro tenant usa ese formato, así que
// para ellos la unidad sigue siendo "paq".
import { z } from 'zod';
export const unidadMedidaSchema = z.enum(['paq', 'kg']);
/** 'kg' solo para formato GRANEL (sin distinguir mayúsculas); 'paq' en otro caso. */
export function unidadDeFormato(formato) {
    return formato?.trim().toUpperCase() === 'GRANEL' ? 'kg' : 'paq';
}
/**
 * Unidad de un conjunto de SKUs (p. ej. lo que corrió una línea en un
 * período): 'kg' solo si hay al menos uno y todos son GRANEL. Mezcla o vacío
 * → 'paq', que es el comportamiento histórico.
 */
export function unidadDeFormatos(formatos) {
    return formatos.length > 0 && formatos.every((f) => unidadDeFormato(f) === 'kg') ? 'kg' : 'paq';
}
//# sourceMappingURL=unidad_medida.js.map